var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"MatcLight"},[_c('h1',[_vm._v("TabelConf Test")]),_c('div',{staticClass:"dialog"},[_c('TableSettings',{attrs:{"app":_vm.app,"value":_vm.widget}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }